import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { MegaOrganisationService, MegaSessionService } from '@megaphone/services'

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  constructor(
    private _router: Router,
    private _megaSessionService: MegaSessionService,
    private _megaOrganisationService: MegaOrganisationService,
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const url = _state.url
    const urlTree = this._router.parseUrl(url)
    const urlWithoutParams = urlTree.root.children['primary']?.segments
      .map((it) => it.path)
      .join('/')

    if (!(await this._checkUserToken(_route.queryParams?.token, urlWithoutParams))) return false
    if (!this._unknownUserGuard(url)) return false
    if (!this._userGuard()) return false

    return true
  }

  private async _checkUserToken(token: string, route: string) {
    if (token) {
      this._megaSessionService.setToken(token)
      await this._megaSessionService.initSession()

      this._router.navigate([route], {
        queryParams: {
          token: null,
        },
        queryParamsHandling: 'merge',
      })

      return false
    }
    return true
  }

  private _unknownUserGuard(url: string) {
    if (localStorage.getItem('token') && this._megaSessionService.session?.logged) {
      this._megaOrganisationService.init()
      // @ToDo admin specific logic
      return true
    }

    // User isn't logged, redirect to the login page

    this._router.navigate(['/auth/login'], {
      queryParams: { returnUrl: url },
    })

    return false
  }

  private _userGuard() {
    const userRoles = this._megaSessionService.attributes$.getValue().roles
    if (userRoles.length <= 1 && userRoles.find((role) => role.role === 'user')) {
      this._router.navigate(['/lost'])
      return false
    }
    return true
  }
}
